export default __webpack_public_path__ + "static/media/collapse.f8772050.svg";